import React from "react";
import { Icon } from "@/components/Icon";
import { useBetSlip } from "@/context/BetSlipContext";
import { useMobilePrefs } from "./MobilePrefs";
import { formatOdds, getOddsFormat } from "@/lib/odds";

/* DockedSlipPill — the white pill that collects bet picks above the tab bar
   (design pattern #03 / PMTabs slip variant). Shows pick count + combined odds;
   tapping opens the full bet-slip sheet. Real data from BetSlipContext — renders
   only when there are picks. Originals use inFlow so the shortcut cannot cover
   their playing fields or action rows. Combined odds = product of real leg decimal prices
   (parlay), formatted in the user's odds format. */

export default function DockedSlipPill({ onOpen, inFlow = false }) {
  const { legs, count } = useBetSlip();
  useMobilePrefs(); // re-render on currency change (sub-label wording is currency-agnostic here)
  if (!count) return null;

  const fmt = getOddsFormat();
  const combined = legs.reduce((acc, l) => acc * (Number(l.odds) || 1), 1);
  const kind = count > 1 ? "Parlay" : "Single";
  const oddsLabel = count > 1 ? formatOdds(combined, fmt) : formatOdds(Number(legs[0]?.odds) || 0, fmt);

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={`Bet slip, ${count} ${count === 1 ? "pick" : "picks"}`}
      style={{
        ...(inFlow ? { position: "static", margin: "16px auto" } : {
          position: "fixed", left: "50%", transform: "translateX(-50%)", zIndex: 41,
          bottom: "calc(64px + env(safe-area-inset-bottom, 0px) + 10px)",
        }),
        width: "calc(100% - 24px)", maxWidth: 456,
        height: 56, boxSizing: "border-box", borderRadius: 18,
        background: "linear-gradient(180deg,#FFFFFF 0%,#E9E9EC 100%)", color: "#0A0A0A",
        display: "flex", alignItems: "center", gap: 12, padding: "0 8px",
        boxShadow: "inset 0 -1px 0 rgba(0,0,0,.08),0 14px 34px rgba(0,0,0,.6)", border: 0, cursor: "pointer",
      }}
    >
      <span style={{ width: 40, height: 40, flex: "none", borderRadius: 12, background: "#0A0A0A", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", font: "800 16px 'Manrope'" }}>
        {count}
      </span>
      <span style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 1, textAlign: "left" }}>
        <span style={{ font: "800 15px 'Manrope'", letterSpacing: "-.01em" }}>Bet slip</span>
        <span style={{ font: "600 12px 'Outfit'", color: "#52525B" }}>{kind} · {count} {count === 1 ? "pick" : "picks"}</span>
      </span>
      <span className="m-tnum" style={{ font: "800 18px 'Manrope'" }}>{oddsLabel}</span>
      <span style={{ width: 40, height: 40, flex: "none", borderRadius: 12, background: "rgba(10,10,10,.06)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name="chevron-up" size={18} style={{ color: "#0A0A0A" }} />
      </span>
    </button>
  );
}
